<template>
  <div class="main">
    <div class="login">
      <div class="customContainer">
          <policy-view></policy-view>
          <div class="row">
            <div class="col">
              <div class="text-center">
              <p class="top__cardShow">
                <button class="button01" @click="back">{{ word_chg('戻る')}}</button>
              </p>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
    <!-- <div id="login" class="text-center container">
        <h1 class="h4 mb-3 font-weight-normal">ログイン</h1>
        <BsLoginForm v-bind:onlogin="handleLogin"></BsLoginForm>
    </div> -->
</template>

<script>
import PolicyView from '../templates/User/PolicyView.vue'
// import '../../assets/bootstrap/css/sc.css';

export default {
    name: 'BsLoginView',
    data: function () {
        return {
            'login_id': '',
            'login_pass': '',
            error: false
        }
    },
    computed: {
        disableLoginAction () { // validを使ってログイン処理の可否、progressは後述
            return false;
        }
    },
    components: {
      PolicyView,
    },
    methods:{
      back(){
        this.$router.go(-1);
      },
      // login御
      async loadUser(obj){
        const params = {};
        if(typeof obj === 'object' && obj.userId){
          params['id'] = obj.userId;
        }
        console.log('bslogin loadUser params', params);
        return this.$store.dispatch('fetchBasicLists', {data: params, target: 'user', targetF: 'get'})
        .catch((err) => {
          console.log(err);
        })
        .then(() => {})
        .finally(() => {});
      },

      async handleLogin(authInfo){
        console.log('handleLogin');
        return this.$store.dispatch('login', authInfo)
          .then(async (res) => {
            await this.loadUser(res);
            
            if(
              typeof res === 'object'
              && typeof res.app_lang_type === 'string' 
              && res.app_lang_type == 'en'
            ){
              window.location.href="/mgcweb/mgwapp/teaser/en.html"
            }else{
              window.location.href="/mgcweb/mgwapp/teaser/"
            }
              // if(process.env.NODE_ENV === 'sandbox' || process.env.NODE_ENV === 'development'){
              //   // this.$router.push({ path: '/teaser' })
              //   console.log('loadUser', res);
              //   if(
              //     typeof res === 'object'
              //     && typeof res.app_lang_type === 'string' 
              //     && res.app_lang_type == 'en'
              //   ){
              //     window.location.href="/mgcweb/mgwapp/teaser/en.html"
              //   }else{
              //     window.location.href="/mgcweb/mgwapp/teaser/"
              //   }
              // }else{
              //   this.$router.push({ path: '/' })
              // }
              // console.log('login success handleLogin', res, authInfo);
              // this.$router.push({ path: '/' })
          })
          .catch(err => {
            console.log('handleLogin', err);
            if(err && err.data && err.data.status != '200'){
              alert('login error');
            }
          })
          .finally(() => {
          });
        },
        // throwReject (err) { return Promise.reject(err) }
    },
}
</script>

<style scoped>
/* @import "../../assets/bootstrap/css/signin.css"; */html,
body {
  height: 100%;
}

body {
  /* display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center; */
  align-items: center;
  /* padding-top: 40px;
  padding-bottom: 40px; */
  background-color: #f5f5f5;
}

.form-signin {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: auto;
}
.form-signin .checkbox {
  font-weight: 400;
}
.form-signin .form-control {
  position: relative;
  box-sizing: border-box;
  height: auto;
  padding: 10px;
  font-size: 16px;
}
.form-signin .form-control:focus {
  z-index: 2;
}
.form-signin input[type="email"] {
  margin-bottom: -1px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.form-signin input[type="password"] {
  margin-bottom: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

</style>
